export const Team = (props) => {
  return (
    <div id='team'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>Teamet bak Eventyrskogene</h2>
          <p>Teamet vårt består av norges fremste kreative krefter, samt svært erfarne fagfolk på blant annet hest og opplevelsesproduksjon.</p>

        </div>
        <div className='row'>
          {props.data
            ? props.data.Team.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  <div className='testimonial'>
                    <div className='testimonial-image'>
                      {' '}
                      <img src={d.img} alt='' />{' '}
                    </div>
                    <div className='testimonial-content'>
                      <div className='testimonial-meta'> {d.name} </div>
                      <p>{d.text}</p>
                      <a href={d.link}>{d.link}</a>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
        <div className='row' style={{marginTop: "10px"}}>
          <h4 className="text-center">Daglig ledelse og prosjekt-ansvarlige</h4>
          {props.data
            ? props.data.Owners.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  <div className='testimonial'>
                    <div className='testimonial-image'>
                      {' '}
                      <img src={d.img} alt='' />{' '}
                    </div>
                    <div className='testimonial-content'>
                      <div className='testimonial-meta'> {d.name} </div>
                      <p>{d.text}</p>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
